<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_10">
				<em class="lt_text">Noticed Date</em>
				<span class="mgr_5">
					<CustomDatePicker v-model="from_date" /> ~
					<CustomDatePicker v-model="to_date" />
				</span>

				<em class="lt_text">Purpose</em>
				<span class="int_type_no_border mgr_5">
					<select v-model="purpose" class="tbl_select">
						<option v-for="(el, index) in purpose_list" :value="el.code" :key="index">{{ el.name }}</option>
					</select>
				</span>

				<em class="lt_text">Payment Term</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect className="tbl_select" :codes="payment_term_code_list" :displayDescription="false" v-model="payment_term_code" />
				</span>

				<em class="lt_text">Recipient</em>
				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="recipient_code" :showName="true" :nameWidth="200" />
				</span>

				<span class="int_type_no_border mgr_5">
					<label><input type="checkbox" v-model="only_fail_result" /> Only Transfer Failed</label>
				</span>

				<a href="javascript:void(0);" class="search_bt mgr_5" @click="getData()">Search</a>
				<a href="javascript:void(0);" class="gray_bt mgr_10" @click="reset()">Reset</a>
			</div>

			<div class="left_option">
				<b style="background: #FFB900;">Please Check if the Yellowed Receipt Phone-No.(Email) is Correct.</b>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl">
					<colgroup>
						<col style="width: 5%;" />
						<col style="width: 6%;" />
						<col />
						<col style="width: 3%;" />
						<col style="width: 12%;" />
						<col style="width: 12%;" />
						<col style="width: 7%;" />
						<col style="width: 5%;" />
						<col style="width: 6%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
					</colgroup>
					<thead>
						<tr>
							<th>Noticed Date</th>
							<th>Partner Code</th>
							<th>Receipt Phone-No.(Email)</th>
							<th>Type</th>
							<th>Reason for Failed Trans.</th>
							<th>Subject</th>
							<th>Invoice No</th>
							<th>Invoice Date</th>
							<th>Payment Term</th>
							<th>Invoice Amt.</th>
							<th>Bal.As of Sending</th>
							<th>Current Bal.</th>
							<th>Curr.Total Bal.</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="send in send_list">
							<template v-if="send && send.invoice_list">
								<tr v-for="(inv, index) in send.invoice_list" :key="send.noti_receipt_no + '/' + inv.invoice_no" class="normal_tbl">
									<!-- <td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_center">{{ send.noti_receipt_no | fillZeroForDisplayNo(8) }}</td> -->
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_center">{{ send.send_date | moment('MM-DD-YYYY') }}</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_center">
										<a href="javascript: void(0);" @click="gotoPartner(send.partner_code)" :title="send.recipient_name">{{ send.partner_code }}</a>
									</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="truncate" :style="send.isValidReceipt ? '' : 'background: #FFB900;'">{{ send.receipt_id_no }}</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_center">{{ send.type }}</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="truncate">{{ send.fail_reason }}</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_center">{{ send.subject }}</td>
									<td class="al_left">
										<a href="javascript: void(0);" @click="gotoInvoice(inv.invoice_no)">{{ inv.invoice_dn }}</a>
									</td>
									<td class="al_center">
										<span v-if="inv.invoice_date">{{ inv.invoice_date | moment('MM-DD-YYYY') }}</span>
									</td>
									<td class="al_left">{{ inv.payment_term_name }}</td>
									<td class="al_right">{{ inv.invoice_amount | toCurrency }}</td>
									<td class="al_right">{{ inv.balance_as_of_sending | toCurrency }}</td>
									<td class="al_right">{{ inv.current_balance | toCurrency }}</td>
									<td v-if="index === 0" :rowspan="send.invoice_list.length" class="al_right">{{ send.total_balance | toCurrency }}</td>
								</tr>
							</template>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { apiSelectARNotificationLog } from '@/api/report/report.js';
import { today, convertMDYToYMD } from '@/utils/date.js';
import { apiSelectCodeList } from '@/api/basicinfo/code.js';
import { inputSelectOnClick, emailRegExp } from '@/utils/etc.js';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
export default {
	data: () => ({
		send_list: [],

		purpose_list: [
			{ code: 'notifyCustomersOfARAmount', name: 'Customer Statement' },
			{ code: 'notifyOfARInAdvance', name: 'AR in Advance' },
		],
		payment_term_code_list: [],

		from_date: null,
		to_date: null,
		purpose: null,
		payment_term_code: null,
		recipient_code: null,
		only_fail_result: false,
	}),
	components: {
		PartnerSelect,
		CustomDatePicker,
		CodeSelect,
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		gotoInvoice(invoice_no) {
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { invoice_no: invoice_no } });
			window.open(routeData.href, '_blank');
		},
		gotoPartner(code) {
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: code } });
			window.open(routeData.href, '_blank');
		},
		sumBalanceBySendLog(send_log) {
			let sum_bal = 0;
			if (send_log && send_log.invoice_list) send_log.invoice_list.forEach(inv => (sum_bal += inv.current_balance));

			return sum_bal;
		},
		phoneRegExp(str) {
			const regExp = /^\+(\d{10,})/i;
			return regExp.test(str);
		},
		reset() {
			this.from_date = today();
			this.to_date = today();
			this.purpose = null;
			this.payment_term_code = null;
			this.recipient_code = null;
			this.only_fail_result = false;
		},
		async getIndex() {
			const { data } = await apiSelectCodeList({ active_yn: 'Y', code_type: 'PT' });
			this.payment_term_code_list = data.codeList;
		},
		async getData() {
			const { data } = await apiSelectARNotificationLog(convertMDYToYMD(this.from_date), convertMDYToYMD(this.to_date), this.purpose, this.payment_term_code, this.recipient_code, this.only_fail_result);
			data.forEach(send => {
				send.total_balance = this.sumBalanceBySendLog(send);
				if (send.type === 'EMAIL') send.isValidReceipt = emailRegExp(send.receipt_id_no);
				if (send.type === 'SMS') send.isValidReceipt = this.phoneRegExp(send.receipt_id_no);
			});
			this.send_list = data;
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_ar_notification_log');
		this.$store.commit('setSubTitle', 'Report -> AR Notification Log');

		this.reset();
		this.getIndex();

		if (this.user.company_id === 'hairplus') {
			this.purpose_list.push({ code: 'notifyARIndividually', name: 'AR Individually' });
		}
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style scoped>
.list_tbl .normal_tbl td {
	background-color: white;
}

.list_tbl .normal_tbl td:last-child {
	border-right: 1px solid #dbdbdb;
}
</style>
